import { axiosInstance } from './axios.service'
import {
  IPlaybookReport,
  IPlaybookReportResponse,
  IAllPlaybookReportsResponse,
} from '../../shared/types/api/playbook.type'
import { IResponse } from '../types/response.type'
import { IMessageResponse } from '../../shared/types/api/message.type'

export const getPlaybookReports = async (playbookId: number): Promise<IResponse<IPlaybookReport[]>> => {
  const resp = await axiosInstance.get<IAllPlaybookReportsResponse>(`playbooks/${playbookId}/reports`)

  return resp.data
}

export const createPlaybookReport = async (
  playbookId: number,
  body: { name: string; slug: string; query: string; params?: string[] },
): Promise<IResponse<IPlaybookReport>> => {
  const resp = await axiosInstance.post<IPlaybookReportResponse>(`playbooks/${playbookId}/reports`, body)

  return resp.data
}

export const updatePlaybookReport = async (
  playbookId: number,
  id: number,
  body: { name?: string; slug?: string; query?: string; params?: string[] },
): Promise<IResponse<IPlaybookReport>> => {
  const resp = await axiosInstance.put<IPlaybookReportResponse>(`playbooks/${playbookId}/reports/${id}`, body)

  return resp.data
}

export const deletePlaybookReport = async (playbookId: number, id: number): Promise<IMessageResponse> => {
  const resp = await axiosInstance.delete<IMessageResponse>(`playbooks/${playbookId}/reports/${id}`)

  return resp.data
}

export const runPlaybookReport = async (
  playbookSlug: string,
  reportSlug: string,
  params: Record<string, string>,
): Promise<Record<string, unknown>[]> => {
  const resp = await axiosInstance.get<Record<string, unknown>[]>(
    `v1/playbooks/${playbookSlug}/reports/${reportSlug}`,
    {
      params,
    },
  )

  return resp.data
}
